import dynamic from 'next/dynamic';
import React, { FC, useEffect, useState } from 'react';

import type { Props } from './TipTapViewer.Lazy';

const preload = () => import('./TipTapViewer.Lazy');

const useTipTapLoaded = () => {
    const [loaded, load] = useState(false);

    useEffect(() => {
        preload().then(() => {
            load(true);
        });
    }, []);

    return loaded;
};

const LazyTipTapViewer = dynamic(preload, {
    ssr: false,
});

const TipTapViewer: FC<Props> = (props) => <LazyTipTapViewer {...props} />;

export { TipTapViewer, preload, useTipTapLoaded };
